<script lang="ts">
	import BenefitsStrip from "@components/sections/BenefitsStrip.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import translations from "./TaglineStrip.translations.json" with { type: "json" };

	const translate = getTranslate(translations);
</script>

<BenefitsStrip items={[translate("tagline")]} />
